module.exports = __webpack_public_path__ + "static/media/1.ef8e0aea.jpg";